import styled from 'styled-components';

const Page = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: #f5f4f7;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media only screen and (max-width: 620px) {
    justify-content: flex-start;
  }
`;

export default Page;
